import React from "react";
// import React, { Suspense } from "react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { createRoot } from "react-dom/client";
// import Spinner from "./components/spinner/Spinner";
import "react-toastify/dist/ReactToastify.css";

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <Suspense fallback={<Spinner />}> */}
      <App />
      {/* </Suspense> */} 
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
